import { Component, ErrorInfo, PropsWithChildren } from "react";
import SectionTitle from "./SectionTitle";
import styles from "./ErrorBoundary.module.css";
import ColumnButton from "./ColumnButton";
import Icon from "./Icon";

class ErrorBoundary extends Component<PropsWithChildren<{}>> {
  state: {
    hasError: boolean;
    error: Error | null;
    errorInfo: ErrorInfo | null;
  };

  constructor(props: {}) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ hasError: true, error, errorInfo });

    console.error(error);
  }

  onRetry = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.wrapper}>
          <SectionTitle>
            <Icon name="error" color="dark" />
            Something went wrong!
          </SectionTitle>
          <p className={styles.error}>{String(this.state.error)}</p>
          <p className={styles.error}>
            {String(this.state.errorInfo?.componentStack)}
          </p>

          <p>Change selected column or method & retry</p>

          <div>
            <ColumnButton onClick={this.onRetry} isActive={false}>
              Retry
            </ColumnButton>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
